import React, { Component } from 'react';
import { Link } from 'react-router';
import Icon from 'react-svg-icon';

export default class ServiceTile extends Component {
    render() {
        const { service } = this.props;
        let link = '';
        if (service.linkTo) {
            link = service.linkTo;
            if (service.class) {
                link += `/${service.class}`;
            }
            return (
                <Link to={link}>
                    <article className={service.class}>
                        <div className="box icon">
                            <Icon name={`i-${service.class}`} />
                            <h3>{service.service}</h3>
                        </div>
                    </article>
                </Link>
            )
        }
        else {
            return (
                <article className={service.class}>
                    <div className="box icon">
                    <img data-srcset={
                                `${service.icon.replace('f_auto', 'c_scale,f_auto,w_153')} 500w ,
                                 ${service.icon.replace('f_auto', 'c_scale,f_auto,w_177')} 640w,
                                 ${service.icon} 1024w`
                            } alt={service.service} className="img-responsive lazyload"/>
                        <h3>{service.service}</h3>
                    </div>
                </article>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ServiceTile.js